import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { Select } from 'antd';
import $ from 'jquery';
  
  const { Option } = Select

  var optionsEntidade = [];
  var optionsEntidadeData = [];
  var entidadeSelected = null;
  var DropDownCellTipoVasilha = null;
  var thisMySelect = null;
  var dataItemOutro;
  function myFunction(selection) {
    optionsEntidade = [];
    (async (e) => {

      entidadeSelected = selection != null ? selection : $('#id-select-Entidade [name="form-field-name"]').val();

      const data = {"IDEntidade": entidadeSelected}
      const EtiquetasSeguranca = await services.apiCall.requestApi(
          "/Fiscalizacao/GetAllEtiquetasSegurancaEntidade",
          data,
          "get"
      );

      console.log('EtiquetasSeguranca');

      if(EtiquetasSeguranca){
        EtiquetasSeguranca.map((Etiqueta, index) => (
          optionsEntidade.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }
    })();
  };



class SelectCellEtiquetasSelagem extends React.Component {
  
  static changeValueFromSelect = (e) => {

    myFunction(e);

  }

  static changeValueFromSelectNumeroVasilha = (e) => {
    (async () => {
      console.log(e)
      if(e != undefined){
        var idVas = e.value.value
        const data = {"IDVasilha": idVas}
        const EtiquetasSeguranca = await services.apiCall.requestApi(
            "Fiscalizacao/GetSelosEtiquetasVasilha",
            data,
            "get"
        );
  
        console.log('EtiquetasSeguranca');
  
        if(EtiquetasSeguranca.etiquetasSeguranca){
          var DataEtiqueta = []
          if(EtiquetasSeguranca.etiquetasSeguranca.length > 0){
            for (let index = 0; index < EtiquetasSeguranca.etiquetasSeguranca.length; index++) {
              var idEtiqueta = EtiquetasSeguranca.etiquetasSeguranca[index].idEtiqueta;
              DataEtiqueta.push(idEtiqueta)
            }
            if(thisMySelect != null){
              thisMySelect.handleChangeCertProcSelosSeg(DataEtiqueta)
            }
           
          }else{
            if(thisMySelect != null){
              thisMySelect.handleChangeCertProcSelosSeg(DataEtiqueta)
            }
           
          }
        }  
      }
      
    })();

  }

  handleChangeCertProcSelosSeg = (e) => {

    var dataItemArray = [];
    var dataItemArrayField = [];

    for(let i = 0; i < e.length; i++){
      dataItemArray.push(optionsEntidade.find(c=> c.props.value == e[i]).props)
    }

    optionsEntidadeData[this.props.field] = (dataItemArray.length > 0 ? dataItemArray : []);

    this.props.onChange({
      dataItem: dataItemOutro.dataItem,
      field: this.props.field,
      syntheticEvent: e != null ? e.syntheticEvent : null,
      value: e.length > 0 ? e : null
    });

  }

  render() {

    thisMySelect = this;

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var dataValue = dataItem[field] === null ? '' : dataItem[field];
   
        
    if(this.props.dataItem.inEdit == true){
      dataItemOutro = this.props
    }
    var StringArray = "";

    return (
        <td>
            {this.props.dataItem.inEdit ?
            
            <Select
                mode="multiple"
                allowClear
                optionFilterProp="children"
                placeholder="Selecione as Etiquetas de segurança"
                value={dataValue != null && dataValue != "" ? dataValue.map((value) => (
                  optionsEntidade.find(c=> c.props.value == value).props.value
                )) : undefined}
                onChange={this.handleChangeCertProcSelosSeg}
                style={{ width: "100%" }}>
                {
                  optionsEntidade
                }
            </Select>

            : dataValue != null  &&  dataValue != "" ?  dataValue.map((value,index) => (
              <span key={index} className="ant-select-selection-item-content-etiquetas">{optionsEntidade.find(c=> c.props.value == value).props.children}</span>
              )) : undefined}

        </td>
  )};
    
}
export default SelectCellEtiquetasSelagem;